import { useMemo } from 'react';
import { DimensionColNames } from '@blisspointmedia/bpm-types/dist/Columns';
import { useExperimentFlag } from '../experiment-context';

export const useExperimentalAnalyticsCols = (): Set<DimensionColNames> => {
  const enableAdGroupNameAnalytics = useExperimentFlag('enableAdGroupNameAnalyticsComboScps');
  const enableAdNameAnalytics = useExperimentFlag('enableAdGroupNameAnalyticsComboScps');

  const expAnalyticsCols = useMemo(() => {
    const expCols = new Set<DimensionColNames>();
    if (enableAdGroupNameAnalytics) {
      expCols.add('ad_group_name');
    }
    if (enableAdNameAnalytics) {
      expCols.add('ad_name');
    }
    return expCols;
  }, [enableAdGroupNameAnalytics, enableAdNameAnalytics]);

  return expAnalyticsCols;
};
